import { PageHeader } from '@lmc/ui-kit'
import useResidentFullName from 'hooks/useResidentFullName'
import { NAMESPACE } from 'locale'
import { transferRecordConstants as trConstants } from 'locale/transferRecords'
import type React from 'react'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router-dom'
import { TransferRecordList } from './components/TransferRecordList'
import { useTransferRecordsList } from './hooks/useTransferRecordsList'

export const ResidentTransferRecordsScreen: React.FC = () => {
  const { t } = useTranslation(NAMESPACE.TRANSFER_RECORDS)
  const { id: residentId } = useParams<{ id: string }>()

  const residentName = useResidentFullName(residentId)

  const { records, isLoading, fetchNextPage, hasNextPage, isFetchingNextPage } =
    useTransferRecordsList({
      residentId: residentId || ''
    })

  return (
    <>
      <PageHeader
        title={
          residentName
            ? t(trConstants.TRANSFER_RECORDS_FOR, { name: residentName })
            : t(trConstants.TRANSFER_RECORDS)
        }
        help={{
          content: t(trConstants.TRANSFER_RECORDS_TOOLTIP)
        }}
        sticky
      />

      <TransferRecordList
        records={records}
        isLoading={isLoading}
        fetchNextPage={fetchNextPage}
        hasNextPage={hasNextPage}
        isFetchingNextPage={isFetchingNextPage}
      />
    </>
  )
}
